module.exports = __webpack_public_path__ + "img/design4.bd9cd3bb.png";